import { EntityBase } from '@provision/entity-types';
import { ReactNode } from 'react';

import { ConversationAttribute } from 'src/graphql/entities/custom-view/custom-view-config/conversation';
import {
  ConversationStatusField,
  ConversationUrgencyField,
  TypeField,
} from './conversation-components';

interface ConversationAttributeValueMap {
  [ConversationAttribute.type]: string;
  [ConversationAttribute.conversationStatus]: string;
  [ConversationAttribute.conversationUrgency]: string;
}

type ConversationRow = EntityBase & {
  snoozeUntil?: string | null;
};

export type ConversationCustomComponent<T extends keyof ConversationAttributeValueMap> = (
  value: ConversationAttributeValueMap[T],
  record: ConversationRow,
) => ReactNode;

export const conversationCustomComponents: {
  [K in keyof ConversationAttributeValueMap]: ConversationCustomComponent<K>;
} = {
  [ConversationAttribute.type]: (value: string) => <TypeField type={value} />,
  [ConversationAttribute.conversationStatus]: (
    conversationStatusId: string,
    record: ConversationRow,
  ) => (
    <ConversationStatusField
      statusId={conversationStatusId}
      snoozeUntil={record.snoozeUntil}
    />
  ),
  [ConversationAttribute.conversationUrgency]: (urgencyId: string) => (
    <ConversationUrgencyField urgencyId={urgencyId} />
  ),
};
